import { getCropUrl } from '../../../Helpers/utils';
import { ImageModel } from '../../../models/ImageModel';
import { TileModel } from '../../models/TileModel';

export default function NewsroomDetailsTile({ node }: TileModel) {
  const name = node.name.length > 50 ? `${node.name.substring(0, 49)}...` : node.name;
  const image = node.properties['image'] as ImageModel ?? null;

  return (
    <div className="cell blog-post-wrapper">
      <div className="thumbnail">
          <a href={node.url}>
              <img src={getCropUrl(image, 'tile')} alt={node.name} />
              <div className="caption">
                  <h6>{name}</h6>
                  <div dangerouslySetInnerHTML={ { __html: node.properties['summary']}} >
                  </div>
                  <span className="go"><i className="fa fa-angle-right"></i></span>
              </div>
          </a>
        </div>
    </div>
  )
}